'use client';

import { ProductAnalysisEntity } from '@/entities/product-analysis.entity';
import { FC } from 'react';
import { useAuth } from '@/context/auth.context';
import { useProductAnalysisModalController } from '@/components/product-analysis-modal/use-product-analysis-modal-controller';
import { ProductAnalysisModalView } from '@/components/product-analysis-modal/ProductAnalysisModalView';

type ProductAnalysisModalProps = {
    isShown: boolean;
    setIsShown: (value: boolean) => void;
    data: ProductAnalysisEntity | null;
    loading: boolean;
    error: string | null;
    productName: string;
};

const ProductAnalysisModal: FC<ProductAnalysisModalProps> = ({
    isShown,
    setIsShown,
    data,
    loading,
    error,
    productName,
}) => {
    const { accessToken } = useAuth();
    const {
        isExportLoading,
        timelineBounds,
        totalWindowDays,
        normalizedWindowWidthDays,
        maxWindowStartOffsetDays,
        normalizedWindowStartOffsetDays,
        maxTimelineAggregationWindowDays,
        normalizedTimelineAggregationWindowDays,
        selectedTimeWindow,
        selectedWindowEndTimestamp,
        reviewsTimelinePoints,
        filteredAnalysis,
        setWindowWidthDays,
        setWindowStartOffsetDays,
        setTimelineAggregationWindowDays,
        exportPdfReport,
    } = useProductAnalysisModalController({
        data,
        loading,
        error,
        productName,
        accessToken,
    });

    return (
        <ProductAnalysisModalView
            isShown={isShown}
            setIsShown={setIsShown}
            loading={loading}
            error={error}
            productName={productName}
            isExportLoading={isExportLoading}
            timelineBounds={timelineBounds}
            totalWindowDays={totalWindowDays}
            normalizedWindowWidthDays={normalizedWindowWidthDays}
            maxWindowStartOffsetDays={maxWindowStartOffsetDays}
            normalizedWindowStartOffsetDays={normalizedWindowStartOffsetDays}
            maxTimelineAggregationWindowDays={maxTimelineAggregationWindowDays}
            normalizedTimelineAggregationWindowDays={normalizedTimelineAggregationWindowDays}
            selectedTimeWindow={selectedTimeWindow}
            selectedWindowEndTimestamp={selectedWindowEndTimestamp}
            reviewsTimelinePoints={reviewsTimelinePoints}
            filteredAnalysis={filteredAnalysis}
            setWindowWidthDays={setWindowWidthDays}
            setWindowStartOffsetDays={setWindowStartOffsetDays}
            setTimelineAggregationWindowDays={setTimelineAggregationWindowDays}
            exportPdfReport={exportPdfReport}
        />
    );
};

export default ProductAnalysisModal;
